/* eslint-disable no-console */
import {PlusOutlined, MinusOutlined} from '@ant-design/icons';
import {Card, Button, Table, Tag, Typography} from 'antd';
import React, {useState} from 'react';

import envIcon from '../../../../assets/environmental.png';
import govIcon from '../../../../assets/governance.png';
import socialIcon from '../../../../assets/social.png';
import useCompanyStore from '../../../../store/companyStore/companyDetailsStore';
import {OPKey} from '../../../configurator/orgFacility/orgInfo/constants/orgProfileKeyLabel';
import {subCategoryWiseMetrics} from '../../constants/gapAnalysis/gapAnalysisMetricsConstants';

const {Text, Title} = Typography;
// sub_category_changes
interface ITextColor {
  text: string;
  color: string;
}

const columns = [
  {
    title: 'ESG Metric',
    dataIndex: 'metric',
    key: 'metric'
  },
  {
    title: 'Peer Average',
    dataIndex: 'average',
    key: 'average',
    render: (obj: ITextColor) => {
      return <Tag color={obj.color}>{obj.text}</Tag>;
    }
  },
  {
    title: 'Gap Analysis',
    dataIndex: 'gap',
    key: 'gap'
  },
  {
    title: 'Insights',
    dataIndex: 'insight',
    key: 'insight'
  }
];

const GapAnalysisSection: React.FC = () => {
  const [expandedKey, setExpandedKey] = useState<string | null>(null);
  const companyDetails = useCompanyStore.getState().companyDetails;
  const subCategory: number = companyDetails[OPKey.SUB_CATEGORY];


  // sub_category_changes
  const sections = [
    {
      key: 'env',
      title: 'Environmental',
      metrics: 8,
      image: envIcon,
      datasource: subCategoryWiseMetrics(subCategory).environmentalMetrics
    },
    {
      key: 'social',
      title: 'Social',
      metrics: 7,
      image: socialIcon,
      datasource: subCategoryWiseMetrics(subCategory).socialMetrics
    },
    {
      key: 'gov',
      title: 'Governance',
      metrics: 2,
      image: govIcon,
      datasource: subCategoryWiseMetrics(subCategory).governanceMetrics
    }
  ];

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: 16}}>
      {sections.map((section) => {
        const isExpanded = expandedKey === section.key;

        return (
          <Card
            key={section.key}
            bordered
            style={{borderRadius: 8, border: '1px solid #dee2e6'}}
            bodyStyle={{padding: 16}}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <div style={{display: 'flex', gap: 16, alignItems: 'center'}}>
                <img
                  src={section.image}
                  alt={section.title}
                  style={{width: 'auto', height: 130, borderRadius: 8}}
                />
                <div>
                  <Title level={5} style={{margin: 0, fontWeight: '700'}}>
                    {section.title}
                  </Title>
                  <Text type="secondary" style={{fontWeight: '700'}}>
                    Compared to{' '}
                  </Text>
                  <span style={{fontWeight: 'bold'}}>
                    {section.metrics} Metrics
                  </span>
                </div>
              </div>

              <Button
                type="default"
                shape="circle"
                icon={
                  isExpanded ? (
                    <MinusOutlined style={{fontSize: '20px'}} />
                  ) : (
                    <PlusOutlined style={{fontSize: '20px'}} />
                  )
                }
                onClick={() => {
                  setExpandedKey(isExpanded ? null : section.key);
                }}
                style={{
                  backgroundColor: '#6C9C5A',
                  color: 'white',
                  height: '50px',
                  width: '50px'
                }}
              />
            </div>

            {isExpanded && (
              <div style={{marginTop: 20}}>
                <Table
                  dataSource={section.datasource}
                  columns={columns}
                  pagination={false}
                  size="middle"
                />
              </div>
            )}
          </Card>
        );
      })}
    </div>
  );
};

export default GapAnalysisSection;
